import { render } from "./Sparkline.vue?vue&type=template&id=95f64fb2"
import script from "./Sparkline.vue?vue&type=script&lang=js"
export * from "./Sparkline.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__